import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { RbacSettingList } from 'gen/rtk-openapi'
import { useMemo } from 'react'

interface MenuOption {
  title: string
  action: string
  module: string
}

export const useAccessibleRoutes = (options: MenuOption[]) => {
  const { roles } = useAppSelector(state => state.permissions)
  const settingsData = useAppSelector(state => state.settings.settings)
  const userRole = roles[0]?.roleName

  const rbacMap = useMemo(() => {
    // If RBAC settings don't exist OR user is yardAdmin, return null to indicate no restrictions
    if (!settingsData?.adminSettings?.rbac || userRole === 'yardAdmin') return null

    const routeAccessMap: Record<string, boolean> = {}
    const roleBasedPermissions: RbacSettingList = settingsData.adminSettings.rbac[userRole]

    if (roleBasedPermissions) {
      roleBasedPermissions.forEach(rootModulePermission => {
        routeAccessMap[rootModulePermission.route] = rootModulePermission.allow
      })
    }
    return routeAccessMap
  }, [settingsData?.adminSettings?.rbac, userRole])

  // Filter options based on both RBAC permissions and module access
  const accessibleOptions = options.filter(option => {
    // If rbacMap is null, allow all options
    if (rbacMap === null) return true

    // Otherwise check module access
    const moduleAccess = rbacMap[option.module] ?? false
    return moduleAccess
  })

  return accessibleOptions
}
